import { render, staticRenderFns } from "./apptop.vue?vue&type=template&id=1c165e8c&scoped=true&"
import script from "./apptop.vue?vue&type=script&lang=js&"
export * from "./apptop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c165e8c",
  null
  
)

export default component.exports